module.exports = __webpack_public_path__ + "static/media/img_hana01.cd4bc2f8.png";